import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrustedCertificatesApiService {

  readonly certificateUrl: string = 'certificate';

  constructor(private http: HttpClient) {}

  public getCertificates(): Observable<any> {
    return this.http.get(this.certificateUrl);
  }

  public addCertificate(certificate): Observable<any> {
    return this.http.post(this.certificateUrl, certificate);
  }

  public removeCertificate(certificateAlias): Observable<any> {
    return this.http.delete(`${this.certificateUrl}/${certificateAlias}`, certificateAlias);
  }
}
